'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WrapperLocation, _BubbleTailWrapperLoc;

var _templateObject = _taggedTemplateLiteral(['\n    padding-right: 20px;\n    .initial-message-close-button {\n      right: inherit !important;\n      left: 8px;\n    }\n  '], ['\n    padding-right: 20px;\n    .initial-message-close-button {\n      right: inherit !important;\n      left: 8px;\n    }\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    padding-left: 20px;\n  '], ['\n    padding-left: 20px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 260px;\n  &.mobile {\n    width: inherit;\n  }\n  ', ';\n'], ['\n  width: 260px;\n  &.mobile {\n    width: inherit;\n  }\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    left: 40px;\n    right: inherit;\n    transform: scaleX(-1);\n  '], ['\n    left: 40px;\n    right: inherit;\n    transform: scaleX(-1);\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    left: inherit;\n    right: 40px;\n  '], ['\n    left: inherit;\n    right: 40px;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: absolute;\n  bottom: -22px;\n  ', ';\n'], ['\n  position: absolute;\n  bottom: -22px;\n  ', ';\n']);

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _UIImage = require('UIComponents/image/UIImage');

var _UIImage2 = _interopRequireDefault(_UIImage);

var _UIIcon = require('UIComponents/icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _Constants = require('ui-addon-avatars/Constants');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _WidgetLocations = require('./constants/WidgetLocations');

var _Images = require('../visitor-widget/constants/Images');

var _InitialMessageAvatars = require('./components/InitialMessageAvatars');

var _InitialMessageAvatars2 = _interopRequireDefault(_InitialMessageAvatars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var WrapperLocation = (_WrapperLocation = {}, _defineProperty(_WrapperLocation, _WidgetLocations.LEFT_ALIGNED, (0, _styledComponents.css)(_templateObject)), _defineProperty(_WrapperLocation, _WidgetLocations.RIGHT_ALIGNED, (0, _styledComponents.css)(_templateObject2)), _WrapperLocation);

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'InitialMessageBubble__Wrapper'
})(_templateObject3, function (_ref) {
  var widgetLocation = _ref.widgetLocation;
  return WrapperLocation[widgetLocation] || WrapperLocation[_WidgetLocations.RIGHT_ALIGNED];
});

var BubbleTailWrapperLocation = (_BubbleTailWrapperLoc = {}, _defineProperty(_BubbleTailWrapperLoc, _WidgetLocations.LEFT_ALIGNED, (0, _styledComponents.css)(_templateObject4)), _defineProperty(_BubbleTailWrapperLoc, _WidgetLocations.RIGHT_ALIGNED, (0, _styledComponents.css)(_templateObject5)), _BubbleTailWrapperLoc);

var BubbleTailWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'InitialMessageBubble__BubbleTailWrapper'
})(_templateObject6, function (_ref2) {
  var widgetLocation = _ref2.widgetLocation;
  return BubbleTailWrapperLocation[widgetLocation] || BubbleTailWrapperLocation[_WidgetLocations.RIGHT_ALIGNED];
});

exports.default = _react2.default.createClass({
  displayName: 'InitialMessageBubble',

  propTypes: {
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    initialMessage: _react.PropTypes.string.isRequired,
    initialMessageBubbleIsEnabled: _react.PropTypes.bool.isRequired,
    isVisible: _react.PropTypes.bool.isRequired,
    mobile: _react.PropTypes.bool.isRequired,
    onClick: _react.PropTypes.func.isRequired,
    onClose: _react.PropTypes.func.isRequired,
    onUpdateSize: _react.PropTypes.func.isRequired,
    setInitialMessageRef: _react.PropTypes.func,
    widgetIsOpen: _react.PropTypes.bool.isRequired,
    widgetLocation: _WidgetLocations.WidgetLocationProp
  },

  getDefaultProps: function getDefaultProps() {
    return {
      mobile: false,
      onUpdateSize: function onUpdateSize() {},
      setInitialMessageRef: function setInitialMessageRef() {}
    };
  },
  componentDidUpdate: function componentDidUpdate(nextProps) {
    if (nextProps.initialMessage !== this.props.initialMessage) {
      this.props.onUpdateSize();
    }
  },
  renderAvatar: function renderAvatar() {
    var _props = this.props,
        chatHeadingConfig = _props.chatHeadingConfig,
        chatHeadingResponders = _props.chatHeadingResponders,
        mobile = _props.mobile,
        onClick = _props.onClick;


    var avatarHeightPx = mobile ? _Constants.AVATAR_SIZES.sm : _Constants.AVATAR_SIZES.md;
    return _react2.default.createElement(
      'div',
      {
        className: 'initial-message-avatar justify-center',
        onClick: onClick,
        style: {
          top: -avatarHeightPx / 2
        }
      },
      _react2.default.createElement(_InitialMessageAvatars2.default, {
        chatHeadingConfig: chatHeadingConfig,
        chatHeadingResponders: chatHeadingResponders,
        mobile: mobile
      })
    );
  },
  renderCloseButton: function renderCloseButton() {
    return _react2.default.createElement(
      _UIButton2.default,
      {
        'aria-label': _I18n2.default.text('conversations-visitor-experience-components.visitorExperienceAriaLabels.dismiss'),
        className: 'initial-message-close-button',
        use: 'unstyled',
        size: 'extra-small',
        responsive: false,
        onClick: this.props.onClose
      },
      _react2.default.createElement(_UIIcon2.default, { name: 'remove' })
    );
  },
  render: function render() {
    var _props2 = this.props,
        initialMessage = _props2.initialMessage,
        onClick = _props2.onClick,
        mobile = _props2.mobile,
        setInitialMessageRef = _props2.setInitialMessageRef,
        widgetIsOpen = _props2.widgetIsOpen,
        initialMessageBubbleIsEnabled = _props2.initialMessageBubbleIsEnabled,
        isVisible = _props2.isVisible,
        widgetLocation = _props2.widgetLocation;


    if (widgetIsOpen || !initialMessageBubbleIsEnabled || !isVisible) {
      return false;
    }

    return _react2.default.createElement(
      Wrapper,
      {
        className: (0, _classNames2.default)('p-top-8', 'p-bottom-4', {
          mobile: mobile
        }),
        tabIndex: '0',
        'aria-live': 'assertive',
        'aria-label': initialMessage,
        role: 'alert',
        ref: setInitialMessageRef,
        widgetLocation: widgetLocation
      },
      _react2.default.createElement(
        'div',
        { className: 'initial-message-bubble' },
        this.renderCloseButton(),
        this.renderAvatar(),
        _react2.default.createElement(
          'p',
          {
            className: 'initial-message-text m-top-1 m-bottom-0',
            onClick: onClick
          },
          initialMessage
        ),
        _react2.default.createElement(
          BubbleTailWrapper,
          { widgetLocation: widgetLocation },
          _react2.default.createElement(_UIImage2.default, { src: _Images.initialMessageBubbleTail })
        )
      )
    );
  }
});
module.exports = exports['default'];